import WarningIcon from "@mui/icons-material/Warning";
import {
  Alert,
  Avatar,
  Badge,
  Button,
  Card,
  CardContent,
  Container,
  List,
  ListItem,
  ListItemContent,
  Stack,
  Typography,
} from "@mui/joy";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import { db } from "../config/firebase";
import {
  CryptoCurrencyFormat,
  CurrencyFormat,
  getNetworkCoinPrice,
  updateUserBalance,
  usdToCryptoByPrice,
} from "../config/services";

export default function Confirm() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const [fee, setFee] = React.useState(0);
  const feeUSD = 350;
  const {
    coinname,
    cointype,
    image,
    thumbimage,
    network,
    code,
    balance,
    contractaddress,
  } = state.coin;

  const { amount, coin } = state.data;
  const fromAddress = state.coin.address;
  const toAddress = state.data.address;

  const userInfos = useSelector((state) => state.useInfos);
  const walletData = useSelector((state) => state.walletsData);
  const {
    tron_balance,
    eth_balance,

    id,
  } = userInfos;

  const switchWalletBalance = (key) => {
    switch (key) {
      case "TRC20":
        return tron_balance;
      default:
        return eth_balance;
    }
  };

  const switchNetwork = (key) => {
    switch (key) {
      case "TRC20":
        return { name: "Tron", type: "tron_balance" };
      default:
        return { name: "Ethereum", type: "eth_balance" };
    }
  };

  const selectedNetworkBalance = switchWalletBalance(network);
  const selectedNetworkType = switchNetwork(network).type;
  const selectedNetwork = switchNetwork(network).name;

  const [loading, setLoading] = React.useState(false);
  const [newbalance, setNewbalance] = React.useState(0);
  const [newNetworkBalance, setNewNetworkBalance] = React.useState(0);

  React.useEffect(() => {
    console.log(contractaddress);
    const networkPrice = getNetworkCoinPrice(walletData, network);
    setFee(usdToCryptoByPrice(feeUSD, networkPrice));
    if (!contractaddress) {
      setNewbalance(balance - amount - feeUSD);
      setNewNetworkBalance(selectedNetworkBalance);
    } else {
      setNewbalance(balance - amount);
      setNewNetworkBalance(selectedNetworkBalance - feeUSD);
    }
  }, [
    amount,
    balance,
    contractaddress,
    feeUSD,
    network,
    selectedNetworkBalance,
    walletData,
  ]);

  const submitform = (event) => {
    event.preventDefault();
    setLoading(true);

    // add newbalance
    updateUserBalance(id, cointype, newbalance).then(() => {
      // add new network balance
      updateUserBalance(id, selectedNetworkType, newNetworkBalance).then(() => {
        // add transactions
        const data = {
          fullname: `${userInfos.firstName} ${userInfos.lastName}`,
          email: userInfos.email,
          userid: userInfos.id,
          cointitle: code,
          cointype: cointype,
          selectednetwordtype: selectedNetworkType,
          amount: amount,
          coin: coin,
          recipient: toAddress,
          transaction_type: "Debit",
          confirmation: 0,
          pending: true,
          timestamp: serverTimestamp(),
        };
        const trxRef = doc(collection(db, "users", id, "transactions"));
        setDoc(trxRef, { ...data }).then(() => {
          // add general transaction
          const trxwalletRef = collection(db, "transactionswallet");
          addDoc(trxwalletRef, {
            ...data,
            transactionid: trxRef.id,
          }).then(() => {
            setLoading(false);
            navigate("/success", { state: data });
          });
        });
      });
    });
  };

  return (
    <>
      <HeaderBackButton title={"Send"} />
      <Container>
        <form onSubmit={submitform}>
          <Stack spacing={2}>
            <Card variant="outlined">
              <CardContent>
                <Stack direction="row" spacing={2}>
                  <Badge
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="plain"
                    badgeContent={
                      <Avatar
                        alt="Remy Sharp"
                        src={thumbimage}
                        sx={{ "--Avatar-size": "24px" }}
                      />
                    }
                    badgeInset="14%"
                    sx={{ "--Badge-paddingX": "0px" }}
                  >
                    <Avatar variant="outlined" size="lg" src={image}></Avatar>
                  </Badge>
                  <Stack direction={"column"} spacing={1}>
                    <Typography>
                      <CryptoCurrencyFormat amount={coin} /> {coinname}
                    </Typography>
                    {network}
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
            <Card variant="outlined">
              <CardContent>
                <List>
                  {[
                    { title: "From", value: fromAddress },
                    { title: "To", value: toAddress },
                    {
                      title: "Amount",
                      value: (
                        <CurrencyFormat
                          amount={amount}
                          prefix={"$"}
                          seperator={true}
                        />
                      ),
                    },
                  //  { title: "Network fee", value: `${fee} ${network}` },
                  ].map((detail, index) => (
                    <ListItem key={index}>
                      <ListItemContent>
                        <Typography level="body-sm">{detail.title}</Typography>
                      </ListItemContent>
                      <Typography
                        level="title-sm"
                        noWrap={true}
                        width={"50%"}
                        textAlign={"right"}
                      >
                        {detail.value}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>

            {selectedNetworkBalance < feeUSD ||
            code == "TRX" ||
            code == "ETH" ? (
              <Alert
                startDecorator={<WarningIcon />}
                variant="soft"
                color="warning"
                size="lg"
              >
                <div>
                  <div>Insufficient Gas Fee</div>
                  <Typography level="body-sm" color="warning">
                    You do not have enough
                    {selectedNetwork} to cover network fees
                  </Typography>
                </div>
              </Alert>
            ) : null}
            {newbalance < 0 ? (
              <Alert
                startDecorator={<WarningIcon />}
                variant="soft"
                color="warning"
              >
                <div>
                  <div>Insufficient balance</div>
                  <Typography level="body-sm" color="warning">
                    Please leave some balance in your {selectedNetwork} to use
                    as your gas fee
                  </Typography>
                </div>
              </Alert>
            ) : null}
          </Stack>
          <Stack direction="row" spacing={4} mt={4}>
            <Button
              variant="outlined"
              color="neutral"
              size="lg"
              fullWidth
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              loading={loading}
              type="submit"
              variant="solid"
              color="primary"
              size="lg"
              fullWidth
              disabled={
                selectedNetworkBalance < feeUSD ||
                newbalance < 0 ||
                code == "TRX" ||
                code == "ETH"
              }
              // onClick={() => navigate(-1)}
            >
              Send
            </Button>
          </Stack>
        </form>
      </Container>
    </>
  );
}

/*

<Typography level="body-sm" color="warning">
                    You need <CryptoCurrencyFormat amount={fee} /> {selectedNetwork} to pay the network fee
                  </Typography>
                  */
